import { Container, Top, Bottom, Aplicativo } from './styles';

import { FaWhatsapp } from 'react-icons/fa';

const HeroSection: React.FC = () => {
  return (
    <Container>
      <Top>
        <img src="icons/aplicativos-icon.svg" alt="Ícone de aplicativos" />
        <h1>Aplicativos para transportadoras</h1>
        <p>
          Todos os aplicativos que sua transportadora precisa para ter uma
          plataforma completa e moderna no seu site, totalmente integrados ao
          seu sistema! Isso tudo com foco na usabilidade e experiência do seu
          cliente.
        </p>
        <a
          href="https://api.whatsapp.com/send?phone=556239323632&text=Gostaria%20de%20saber%20mais%20sobre%20os%20aplicativos%20que%20a%20Hyerdev%20desenvolve%20para%20transportadoras"
          target="_blank"
          rel="noreferrer noopener"
        >
          Fale com um especialista <FaWhatsapp size={22} />
        </a>
      </Top>
      <Bottom>
        <Aplicativo>
          <div className="shadow rastreamento-encomenda">
            <img
              src="/aplicativos/rastreamento-encomendas.svg"
              alt="Ícone de rastreamento de encomendas"
            />
          </div>
          <span>Rastreamento de encomendas</span>
        </Aplicativo>
        <Aplicativo>
          <div className="shadow coleta">
            <img
              src="/aplicativos/coleta.svg"
              alt="Ícone de solicitação de coleta"
            />
          </div>
          <span>Solicitação de coleta</span>
        </Aplicativo>
        <Aplicativo exclusive>
          <div className="shadow rastreamento-coleta">
            <img
              src="/aplicativos/rastreamento-coleta.svg"
              alt="Ícone de rastreamento de coletas"
            />
          </div>

          <span>Rastreamento de coletas</span>
        </Aplicativo>
        <Aplicativo exclusive>
          <div className="shadow segunda-via-boleto">
            <img
              src="/aplicativos/2-via-de-boleto.svg"
              alt="Ícone de 2ª via de boletos"
            />
          </div>

          <span>2ª via de boletos</span>
        </Aplicativo>
        <Aplicativo>
          <div className="shadow cotacao">
            <img
              src="/aplicativos/cotacao.svg"
              alt="Ícone de cotação de fretes"
            />
          </div>

          <span>Cotação de fretes</span>
        </Aplicativo>
        <Aplicativo>
          <div className="shadow busca-filiais">
            <img
              src="/aplicativos/busca-filiais.svg"
              alt="Ícone de busca de filiais"
            />
          </div>

          <span>Busca de filiais</span>
        </Aplicativo>
        <a
          href="https://api.whatsapp.com/send?phone=556239323632&text=Gostaria%20de%20saber%20mais%20sobre%20o%20servi%C3%A7o%20de%20disparo%20de%20notifica%C3%A7%C3%B5es%20da%20Hyerdev"
          target="_blank"
          rel="noreferrer noopener"
        >
          Fale com um especialista <FaWhatsapp size={22} />
        </a>
      </Bottom>
    </Container>
  );
};

export default HeroSection;
